import React, {Component} from 'react'
import {markPrinted} from "../../../services/api/3dApi"
import {Input, message} from "antd"
import '../../batches/styles/index.scss'

class MarkPrinted extends Component {
    state = {
        inputValue: '',
        error: '',
        valueTam: '',
        completed: false,
        loading: false,
        timeKeyStart: 0,
        timeKeyEnd: 0,
        strScan: ''
    }

    _input = React.createRef()

    _onSubmit = (e) => {
        e.preventDefault()
        const {valueTam} = this.state

        const check = /^#\d+_/.test(valueTam)

        this.setState({
            inputValue: check ? valueTam : '',
            valueTam: '',
            strScan: valueTam,
            completed: true
        }, () => {
            const valueFormatted = valueTam.trim().replace(/^#/, '')

            if (!valueFormatted) {
                return null
            }

            check && this._rqPrintAction(valueFormatted)
        })
    }

    _handleChange = e => {
        let {value} = e.target
        const {valueTam, strScan} = this.state

        if (value.length > strScan.length) {
            value = value.slice(value.indexOf(strScan) + strScan.length)
        }

        this.setState({
            inputValue: '',
            completed: false,
            valueTam: valueTam + value,
        })
    }

    _rqPrintAction = async (value) => {
        try {
            const payload = {
                itemNumber: value,
            }

            const {data: response} = await markPrinted(payload)

            const {success, error, data} = response

            if (!success) {
                return this.setState({
                    error: error,
                    loading: false,
                    valueTam: ''
                })
            }

            this.setState({
                inputValue: '',
                loading: false,
                valueTam: '',
                error: data.toString() !== 'true' ? data : '',
            })

            message.success('Batches submitted')
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        } finally {
            this._input.current.focus()
        }
    }

    _onPaste = (e) => {
        //e.preventDefault()
    }

    _resetScanInput = () => {
        this.setState({
            inputValue: '',
            valueTam: '',
            error: ''
        })
    }

    render() {
        const {inputValue, error, loading} = this.state

        return (
            <div className='PackagePrintedPage p-5'>
                <div className='row'>
                    <div className='col-8 mx-auto'>
                        <h1>Đánh dấu đã in</h1>
                        <div className="position-relative">
                            <form onSubmit={this._onSubmit}>
                                <Input onPaste={this._onPaste} onChange={this._handleChange} value={inputValue}
                                       size='large' ref={this._input}/>
                                {loading && (
                                    <i className="position-absolute fa fa-spinner fa-spin"/>
                                )}
                                {inputValue && (
                                    <i className="position-absolute fa fa-close cursor-pointer text-dark"
                                       onClick={this._resetScanInput}/>
                                )}
                            </form>
                        </div>
                        {error && (
                            <div className="text-danger errorMessage mt-2">{error}</div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default MarkPrinted
